import {texture} from "p3";
import common from "../common";
import {iswebfont, locale, resizeLabelToFitText} from "../utils";
import GameScene from "./GameScene";
import MenuScene from "./MenuScene";

export default class RateScene extends MenuScene {
    /**
     */
    constructor() {
        super("rate");
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this.createFill();
        this.resizeFill()

        const panel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        panel.width = 520;
        panel.height = 200;
        panel.x = (common.STAGE_WIDTH/2) - (panel.width/2);
        panel.y = common.STAGE_HEIGHT;
        this.addChild(panel);

        let title;
        if (!iswebfont()) {
            title = new PIXI.BitmapText(locale('rate_title').toUpperCase(), {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
        } else {
            title = new PIXI.Text(locale('rate_title').toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 40,
                align: "center",
                fill: 0x0
            });
        }
        title.anchor.set(0.5);
        title.position.set(panel.width/2, !iswebfont() ? 60 : 57);
        panel.addChild(title);
        resizeLabelToFitText(title, panel.width-60);

        const imageHolder = new PIXI.Container();
        imageHolder.position.set(panel.width/2, 110);
        panel.addChild(imageHolder);

        let currentX = 0;
        for (let i = 0; i < 5; i++) {
            let star = new PIXI.Sprite(texture("icon_rating"))
            star.x = currentX;
            imageHolder.addChild(star);
            currentX += (star.width/2) + 5;
        }
        imageHolder.x = (panel.width/2) - (imageHolder.width/2);

        let description;
        if (!iswebfont()) {
            description = new PIXI.BitmapText(locale('rate_description'), {
                fontName: "Alghera Pro",
                fontSize: 30,
                align: "center",
                tint: 0x702311,
                maxWidth: panel.width-60
            });
        } else {
            description = new PIXI.Text(locale('rate_description'), {
                fontFamily: "FredFredBurger",
                fontSize: 30,
                align: "center",
                fill: 0x702311,
                wordWrap: true,
                wordWrapWidth: panel.width-60
            });
        }
        description.anchor.set(0.5, 0);
        description.position.set(panel.width/2, imageHolder.y + (imageHolder.height) + 20 + (!iswebfont() ? 0 : -3));
        panel.addChild(description);

        panel.height = Math.max(panel.height, description.y + description.height + panel.bottomHeight);

        const hidePanel = () => {
            this._tweens.push(
                gsap.to(panel, 0.3, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                    this.signals.next.dispatch();
                }})
            );
        }

        const watchButton = P3.Button.create(texture("btn_rectangle_out"));
        watchButton.overSoundName = "sfx_btn_generic_rollover";
        watchButton.clickSoundName = "sfx_btn_generic_press_00";

        let nameLabel;
        if (!iswebfont()) {
            nameLabel = new PIXI.BitmapText(locale('rate_button').toUpperCase(), {
                fontName: "Alghera Pro Outline",
                fontSize: 32,
                align: "left",
                tint: 0xFFFFFF
            });
        } else {
            nameLabel = new PIXI.Text(locale('rate_button').toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 32,
                align: "left",
                fill: 0xFFFFFF
            });
        }
        nameLabel.y = !iswebfont() ? 0 : -3;
        nameLabel.anchor.set(0.5);
        watchButton._background.addChild(nameLabel);
        resizeLabelToFitText(nameLabel, 280);

        watchButton.x = (panel.width/2);
        watchButton.y = panel.height;
        panel.addChild(watchButton);

        const closeButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_cross"),
        );
        closeButton.x = panel.width;
        closeButton.y = 20;
        panel.addChild(closeButton);

        this.signalListeners.push(
            watchButton.signals.click.add(() => {
                common.saveData.clearRatePopUps();
                common.saveData.saveGame();
                hidePanel();
                if (!!window.cordova) {
                    cordova.plugins.AppReview.requestReview().catch(function() {
                        return cordova.plugins.AppReview.openStoreScreen();
                    });
                }
            }, this)
        )
        
        this.signalListeners.push(
            closeButton.signals.click.add(() => {
                hidePanel();
            }, this)
        );

        this._tweens.push(
            gsap.to(panel, 0.3, {y:(common.STAGE_HEIGHT / 2) - (panel.height/2), ease:Expo.easeOut})
        );
    }

    destroy() {
    
        super.destroy();
    }

    resize() {
        super.resize();
    }
}

/**
 * @static
 * @type {GameScene}
 */
RateScene.active = null;